import ApiUtils from './ApiUtils';
import envConfig from '../../static/config';
import config from '../config';
import AnalyticsUtil from './AnalyticsUtil';
import EgainActionCreator from '../actions/EgainActionCreator';

class EgainUtils {
  static initiateEgainChat() {
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_activity,
      config.analytics.analytics_event_method_interacted,
      config.analytics.analytics_name_egain_chat,
      'click'
    );
    const requestData = {
      saml_service_provider: 'egain',
    };

    const {
      apiBaseUrl,
      apiBaseUrlPAAS,
      endpoints: {
        eGainSaml: { tokenEndpoint, isPAAS },
      },
    } = envConfig;

    const url = isPAAS
      ? `${apiBaseUrlPAAS}/ibapi/v2${tokenEndpoint}`
      : `${apiBaseUrl}${tokenEndpoint}`;

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.samlServices,
        method: 'POST',
        url,
        requestData,
        addAuthToken: true,
      },
      (body) => {
        const saml = body.saml_assertion;
        EgainActionCreator.getSamlTokenSuccess(saml);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  static initiateCobrowse() {
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_activity,
      config.analytics.analytics_event_method_interacted,
      config.analytics.analytics_name_egain_cobrowse,
      'click'
    );
    try {
      window.eGain.cobrowse.startCobrowse();
    } catch (error) {
      console.log(error);
    }
  }
}

export default EgainUtils;
